import React, { useState, useEffect } from "react";
import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  TextField,
  Autocomplete,
  Button,
  Box,
  Accordion,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ModelAutoComplete from "../../basic-information/productModel/ModelAutoComplete";
import TargetAutoComplete from "../../basic-information/productTarget/TargetAutoComplete";
import PUsageAutoComplete from "../../basic-information/productUsage/PUsageAutoComplete";
import { UseProduct } from "./UseProduct";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditLevel3(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { validateLvl3Edit } = UseProduct();
  const [open, setOpen] = useState(false);
  const [selectedGender, setSelectedGender] = React.useState();
  const [level3, setLevel3] = React.useState({
    gender: props.product.gender,
    spf: props.product.spf,
    registerCode: props.product.registerCode,
    targetLocationID: props.product.targetLocationID,
    modelID: props.product.modelID,
    appropriateID: props.product.appropriateID,
  });
  const { isSmall } = useBreakpoints();

  const options = [
    { label: "عمومی", id: 0 },
    { label: "آقایان", id: 1 },
    { label: "بانوان", id: 2 },
  ];

  const [stateValidation, setStateValidation] = useState({
    gender: false,
  });

  useEffect(() => {
    if (props.product) {
      setSelectedGender(options.find((o) => o.id == props.product.gender));
    }
  }, [props.product]);

  useEffect(() => {
    if (props.fire) {
      Validation3();
    }
  }, [props.fire]);

  return (
    <Accordion
      expanded={props.expanded === "panel3"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        onClick={() => props.setExpanded("panel3")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography sx={{ width: "33%", flexShrink: 0 }}>مرحله سوم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle color="red" id="alert-dialog-title">
            توجه!
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              آیا از اتمام ویرایش محصول اطمینان دارید ؟
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => props.setFire(true)}
            >
              بله
            </Button>
            <Button color="secondary" onClick={() => setOpen(false)}>
              خیر
            </Button>
          </DialogActions>
        </Dialog>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <Autocomplete
              size="small"
              fullWidth
              options={options ? options : ""}
              value={selectedGender ? selectedGender : ""}
              getOptionLabel={(option) => (option.label ? option.label : "")}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="جنسیت"
                  error={stateValidation.gender}
                />
              )}
              onChange={(evt, newValue) => {
                if (newValue) {
                  setSelectedGender(newValue);
                  setLevel3({
                    ...level3,
                    gender: newValue.id,
                  });
                }
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              id="outlined-basic"
              size="small"
              value={level3.registerCode ? level3.registerCode : ""}
              label=" پروانه ساخت "
              variant="outlined"
              onChange={(event) => {
                setLevel3({
                  ...level3,
                  registerCode: event.target.value,
                });
              }}
              fullWidth
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TargetAutoComplete
              selectedTargetID={level3.targetLocationID}
              setter={setLevel3}
              lvl3State={level3}
            ></TargetAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <ModelAutoComplete
              selectedModelID={level3.modelID}
              setter={setLevel3}
              lvl3State={level3}
            ></ModelAutoComplete>
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              size="small"
              id="outlined-basic"
              value={level3.spf ? level3.spf : ""}
              label=" spf "
              variant="outlined"
              onChange={(event) => {
                setLevel3({
                  ...level3,
                  spf: event.target.value,
                });
              }}
              fullWidth
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <PUsageAutoComplete
              selectedUsageID={level3.appropriateID}
              setter={setLevel3}
              lvl3State={level3}
            ></PUsageAutoComplete>
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              props.setExpanded("panel2");
            }}
          >
            مرحله قبل
          </Button>
          <Button
            sx={{ mr: 2, width: "100px" }}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            اتمام
          </Button>
          <Button
            sx={{ width: "100px" }}
            variant="contained"
            color="secondary"
            onClick={() => Validation3()}
          >
            مرحله بعد
          </Button>
        </Box>
      </AccordionDetails>
    </Accordion>
  );

  function Validation3() {
    validateLvl3Edit(
      level3,
      setStateValidation,
      (res) => {
        if (props.fire == false) {
          enqueueSnackbar("مرحله سوم با موفقیت تکمیل شد", {
            variant: "success",
            autoHideDuration: 2000,
          });
          props.setExpanded("panel4");
        }
        props.fill(level3);
      },
      props.setFire
    );
  }
}
